import React from "react"
import Img from "components/Img"
import Link from "components/Link"
import Paper from "components/Paper"
import { P2 } from "components/Typography"
import { useNews } from "effects/useSiteContent"
import * as css from "./NewsSection.module.css"
import Section from "components/Layout/Section"
import SectionHeader from "components/Layout/SectionHeader"

function NewsSection() {
  const newsItems = useNews()

  return (
    <Section className={css.root}>
      <div className={css.rectangle} />
      <SectionHeader title="In the News" level="h1" centered margin />
      <div className={css.grid}>
        {newsItems.map((news, index) => (
          <Link className={css.link} href={news.url} key={index}>
            <Paper hoverable className={css.paper}>
              <Img className={css.image} image={news.thumbnail} />
              <P2>{news.title}</P2>
            </Paper>
          </Link>
        ))}
      </div>
    </Section>
  )
}

export default NewsSection
